import { IApplicationState } from '../../types/redux';

export const selectLocation = (state: IApplicationState) => {
  return state.location;
};
